import { render, staticRenderFns } from "./QuoteView.vue?vue&type=template&id=56b7a568&scoped=true"
import script from "./QuoteView.vue?vue&type=script&lang=js"
export * from "./QuoteView.vue?vue&type=script&lang=js"
import style0 from "./QuoteView.vue?vue&type=style&index=0&id=56b7a568&prod&lang=scss&scoped=true"
import style1 from "./QuoteView.vue?vue&type=style&index=1&id=56b7a568&prod&lang=scss"
import style2 from "./QuoteView.vue?vue&type=style&index=2&id=56b7a568&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b7a568",
  null
  
)

export default component.exports